import axios from 'axios'
import request from './index'

export const dologin = (formData) => {
  return request({
    url: '/screen/dologin',
    method: 'post',
    data: {
	  command_id:83,
      username:formData.username,
	  password:formData.password
    }
  })
}